import Http from '@/services/http';
import translate from '@/services/translate';
import {
  OperationsHistoryRequest,
  OperationsReportListRequest,
  OperationHistoryTemplateListResponse,
  InsertTemplateRequest,
  OperationHistoryReportItem,
  OperationsHistoryResponse,
} from 'sigma-mappings';

const urls = {
  history: '/historico-operacoes/listagem',
  insertTemplate: '/historico-operacoes/template',
  exportHistoryExcel: '/historico-operacoes/exportar/excel',
  templateList: '/historico-operacoes/template/listagem',
  removeTemplate: id => `/historico-operacoes/${id}`,
  getTemplate: id => `/historico-operacoes/template/${id}`,
  download: id => `/historico-operacoes/download/${id}`,
  updateTemplate: id => `/historico-operacoes/template/${id}`,
};

const fields = {
  DataInicial: {
    name: 'fields.general.initial-date',
  },
  DataFinal: {
    name: 'fields.general.final-date',
  },
};

/* istanbul ignore next */
const errorHandler = {
  errorHandling: {
    responseMessageParams: {
      $MA001: ({ field }) => {
        const returnedField = fields[field];
        if (!returnedField) return null;
        return {
          NomeDoCampo: translate(returnedField.name),
        };
      },
      $MA009: data => data,
      $ME090: (data) => ({ 0: data.parameters[0] }),
      $ME091: (data) => ({ 0: data.parameters[0] }),
    },
  },
};

export default {
  urls,
  /* istanbul ignore next */
  getOperationHistory(payload) {
    const operationTypePortugueseMap = {
      Login: 'login',
      Alteracao: 'change',
      Exclusao: 'exclusion',
      Inclusao: 'inclusion',
    };
    const validEnglishValues = ['login', 'change', 'exclusion', 'inclusion'];
    const pageSize = payload.filter?.pageSize || payload.pageSize;
    const page = payload.filter?.page || payload.page;

    const payloadWithMappedOperationTypes = {
      ...payload,
      filter: {
        ...payload.filter,
        users: payload.filter?.usersIds || [],
        operationTypes: (payload.filter?.operationTypes || []).map(op => {
          if (validEnglishValues.includes(op)) {
            return op;
          }
          return operationTypePortugueseMap[op] || op;
        }),
      },
      page,
      pageSize,
    };
    const mappedPayload = new OperationsHistoryRequest(payloadWithMappedOperationTypes);
    const http = new Http(errorHandler);
    return http
      .post(urls.history, mappedPayload)
      .then(({ data }) => new OperationsHistoryResponse(data));
    },
  /* istanbul ignore next */
  insertTemplate(params) {
    const http = new Http(errorHandler);
    const mappedParams = new InsertTemplateRequest(params);
    return http.post(urls.insertTemplate, mappedParams)
    .then(({ data }) => data);
  },
  /* istanbul ignore next */
  getTemplateById(id) {
    const http = new Http();
    return http
      .get(urls.getTemplate(id))
      .then(({ data }) => new OperationHistoryReportItem(data));
  },
  /* istanbul ignore next */
  exportHistoryExcel(payload) {
    const operationTypePortugueseMap = {
      Login: 'login',
      Alteracao: 'change',
      Exclusao: 'exclusion',
      Inclusao: 'inclusion',
    };
    const validEnglishValues = ['login', 'change', 'exclusion', 'inclusion'];

    const payloadWithMappedOperationTypes = {
      ...payload,
      filter: {
        ...payload.filter,
        users: payload.filter?.usersIds || [],
        operationTypes: (payload.filter?.operationTypes || []).map(op => {
          if (validEnglishValues.includes(op)) {
            return op;
          }
          return operationTypePortugueseMap[op] || op;
        }),
      },
    };
    const mappedPayload = new OperationsHistoryRequest(payloadWithMappedOperationTypes);
    const http = new Http({
      download: true,
      ...errorHandler,
    });
    return http
      .post(urls.exportHistoryExcel, mappedPayload)
      .then(({ data }) => data);
  },
  getTemplateList(payload) {
    const http = new Http();
    const mappedPayload = new OperationsReportListRequest(payload);
    return http
      .post(urls.templateList, mappedPayload)
      .then(({ data }) => new OperationHistoryTemplateListResponse(data));
  },
  /* istanbul ignore next */
  removeTemplate(reportId) {
    const http = new Http();
    return http.delete(urls.removeTemplate(reportId))
      .then(({ status }) => status === 200);
  },
  downloadTemplate(id) {
    const http = new Http({
      download: true,
    });

    return http
      .get(urls.download(id));
  },
  /* istanbul ignore next */
  updateTemplate(templateId, params) {
    const http = new Http(errorHandler);
    const mappedParams = new InsertTemplateRequest(params);
    return http.put(urls.updateTemplate(templateId), mappedParams);
  },
};
